import { c as _c } from "react/compiler-runtime";
import { createFieldErrorHandler, type VaultFormData } from '@onefootprint/core';
import type { FieldError } from '@onefootprint/hooks';
import type { Language, Locale, OnboardingRequirementCollectCustomData, VaultData } from '@onefootprint/request-types';
import { MarkdownText, PageShell } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ConditionalSection } from './components/conditional-section';
import { PromptRenderer } from './components/prompt-renderer';
import { formatFormData } from './utils/format-form-data';
import { getDefaultValues } from './utils/get-default-values';
export type CollectCustomDataFormData = VaultFormData;
type CollectCustomDataProps = {
  currentRequirement: OnboardingRequirementCollectCustomData;
  isLoading: boolean;
  decryptedVault: VaultData;
  onSubmit: (data: VaultData, onError: (errors: FieldError[]) => void) => void;
  className?: string;
  l10n?: {
    locale?: Locale;
    language?: Language;
  };
  disableSsnValidation?: boolean;
};
export const CollectCustomData = t0 => {
  const $ = _c(38);
  const {
    l10n,
    currentRequirement: t1,
    isLoading,
    decryptedVault,
    onSubmit,
    className,
    disableSsnValidation
  } = t0;
  const {
    page
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "collectCustomData.pages.customDataForm"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t2);
  let t3;
  if ($[1] !== decryptedVault || $[2] !== page.sections) {
    t3 = getDefaultValues(decryptedVault, page.sections, decryptedVault);
    $[1] = decryptedVault;
    $[2] = page.sections;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = {
      defaultValues: t3,
      mode: "onSubmit"
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const methods = useForm(t4);
  let T0;
  let t5;
  let t6;
  if ($[6] !== methods || $[7] !== onSubmit) {
    const handleFieldErrors = createFieldErrorHandler(methods);
    const handleSubmit = async data => {
      onSubmit(formatFormData(data), handleFieldErrors);
    };
    T0 = FormProvider;
    t6 = methods;
    t5 = methods.handleSubmit(handleSubmit);
    $[6] = methods;
    $[7] = onSubmit;
    $[8] = T0;
    $[9] = t5;
    $[10] = t6;
  } else {
    T0 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  const t7 = page.header;
  const t8 = page.subheader;
  let t9;
  if ($[11] !== t) {
    t9 = t(_temp);
    $[11] = t;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = {
      text: t9,
      type: "submit"
    };
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const t11 = className || "flex flex-col gap-4 w-full";
  let t12;
  if ($[15] !== disableSsnValidation || $[16] !== l10n || $[17] !== page.sections) {
    let t13;
    if ($[19] !== disableSsnValidation || $[20] !== l10n) {
      t13 = section => {
        const key = section.kind === "prompt" ? section.di : section.content;
        return <ConditionalSection key={key} section={section}>{section.kind === "text_block" ? <MarkdownText className="text-body-2 text-primary">{section.content}</MarkdownText> : <PromptRenderer content={section} l10n={l10n} disableSsnValidation={disableSsnValidation} />}</ConditionalSection>;
      };
      $[19] = disableSsnValidation;
      $[20] = l10n;
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    t12 = page.sections.map(t13);
    $[15] = disableSsnValidation;
    $[16] = l10n;
    $[17] = page.sections;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <div className={t11}>{t12}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== isLoading || $[26] !== page.header || $[27] !== page.subheader || $[28] !== t10 || $[29] !== t13) {
    t14 = <PageShell title={t7} subtitle={t8} cta={t10} isLoading={isLoading}>{t13}</PageShell>;
    $[25] = isLoading;
    $[26] = page.header;
    $[27] = page.subheader;
    $[28] = t10;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14 || $[32] !== t5) {
    t15 = <form onSubmit={t5}>{t14}</form>;
    $[31] = t14;
    $[32] = t5;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== T0 || $[35] !== t15 || $[36] !== t6) {
    t16 = <T0 {...t6}>{t15}</T0>;
    $[34] = T0;
    $[35] = t15;
    $[36] = t6;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
};
function _temp($) {
  return $.cta;
}